import cn from 'classnames'

export default function NavigatableIntegrationWidgetCard({
  children,
  className,
}) {
  return (
    <div className={cn('NavigatableIntegrationWidgetCard-List', className)}>
      {children}
    </div>
  )
}
